<template>
  <router-link to="/">
    <v-img
      class="logo"
      :lazy-src="require('@/assets/img/hirefly-logo-1.png')"
      :height="width"
      :width="height"
      contain
      :src="require('@/assets/img/hirefly-logo-1.png')"
    ></v-img>
  </router-link>
</template>

<script>
export default {
  props: {
    height: [String, Number],
    width: [String, Number],
  },
};
</script>

<style scoped>
.logo {
  cursor: pointer;
}
</style>
